import { appPaths } from "../../Common";
import { BreadcrumbMap } from "../../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  [appPaths.tags.root]: {
    path: appPaths.tags.root
  },
  [appPaths.tags.details]: {
    path: appPaths.tags.details
  }
};
